import { Button } from './button.js';
import { IconButton } from './iconButton.js';

const SplitButton = {
  baseStyle: {
    buttonGroup: {
      display: "flex",
      alignItems: "stretch",
      borderRadius: "8px",
      width: "max-content",
      height: "max-content"
    },
    primaryButton: {
      ...Button.baseStyle,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    secondaryButton: {
      "&[data-type=icon-button]": {
        minWidth: "unset !important",
        paddingInline: "0px !important"
      },
      ...Button.baseStyle,
      borderLeftRadius: "unset",
      h: "auto",
      _hover: {
        bgColor: "transparent"
      }
    }
  },
  variants: {
    primary: {
      buttonGroup: {
        bgColor: "color-mix(in srgb, var(--vimeo-colors-blue-500) 50%, transparent)"
      },
      primaryButton: {
        ...Button.variants?.primary
      },
      secondaryButton: {
        color: "white"
      }
    },
    secondary: {
      buttonGroup: {
        bgColor: "color-mix(in srgb, var(--vimeo-colors-grayscale-50) 50%, transparent)",
        _dark: {
          bgColor: "color-mix(in srgb, var(--vimeo-colors-grayscale-700) 50%, transparent)"
        }
      },
      primaryButton: {
        ...Button.variants?.secondary
      }
    },
    blur: {
      buttonGroup: {
        backdropFilter: "blur(var(--vimeo-blur-md))",
        "::-moz-backdrop-filter": "blur(var(--vimeo-blur-md))",
        bgColor: "color-mix(in srgb, var(--vimeo-colors-grayAlpha-100) 50%, transparent)",
        _dark: {
          bgColor: "color-mix(in srgb, var(--vimeo-colors-grayAlpha-700) 50%, transparent)"
        }
      },
      primaryButton: {
        ...Button.variants?.blur
      }
    }
  },
  sizes: {
    xs: {
      primaryButton: {
        ...Button.sizes?.xs
      },
      secondaryButton: {
        ...Button.sizes?.xs,
        ...IconButton.sizes?.xs,
        svg: {
          boxSize: "16px"
        }
      }
    },
    sm: {
      primaryButton: {
        ...Button.sizes?.sm
      },
      secondaryButton: {
        ...Button.sizes?.sm,
        ...IconButton.sizes?.sm,
        "&[data-type=icon-button]": {
          paddingInline: "3px !important",
          svg: {
            boxSize: "16px"
          }
        }
      }
    },
    md: {
      primaryButton: {
        ...Button.sizes?.md
      },
      secondaryButton: {
        ...Button.sizes?.md,
        ...IconButton.sizes?.md,
        "&[data-type=icon-button]": {
          paddingInline: "3px !important",
          svg: {
            boxSize: "20px"
          }
        }
      }
    },
    lg: {
      primaryButton: {
        ...Button.sizes?.lg
      },
      secondaryButton: {
        ...Button.sizes?.lg,
        ...IconButton.sizes?.lg,
        "&[data-type=icon-button]": {
          paddingInline: "4px !important",
          svg: {
            boxSize: "20px"
          }
        }
      }
    }
  }
};

export { SplitButton };
